export default __webpack_public_path__ + "static/media/temp-5.6a5aa134.svg";